import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Auth from "../../utils/AuthUtils";
import userAPI from "../../api/UserApi";
import { getTimeAgo } from "../../helper/Helper";
import { FiShoppingBag, FiBox, FiClock, FiDollarSign } from "react-icons/fi";
import { Row } from "react-bootstrap";

function Dashboard() {
  const { username } = Auth.getToken();
  const [orders, setOrders] = useState(null); // Initial state null rakhi h check karne k liye

  useEffect(() => {
    fetchLatestOrder();
  }, []);

  const fetchLatestOrder = async () => {
    try {
      const res = await userAPI.fetchLatestOrder();
      if (res.code === 200) {
        const result = res.data;
        setOrders(result);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div className="custom-account-dashboard">
        {/* Welcome Header */}
        <div className="custom-account-header">
          <span className="badge-text mb-2">USER DASHBOARD</span>
          <h4 className="custom-hello-text">
            Hello, {username || "Snack Partner"}! 👋
          </h4>
          <p className="custom-account-desc">
            Today is a great day to check your account. You can view{" "}
            <NavLink to="/users/orders" className="funky-dash-link">your orders</NavLink> or explore{" "}
            <NavLink to="/shop" className="funky-dash-link">latest products</NavLink>.
          </p>
        </div>

        {/* Dashboard Content */}
        <div className="custom-account-content mt-5">
          <Row className="g-4">
            {orders && orders.orderId ? (
              <div className="col-xl-4 col-md-6 col-sm-12">
                <div className="custom-order-card">
                  {/* Card Sticker Header */}
                  <div className="custom-order-header">
                    <FiBox className="me-2" />
                    <span>LATEST ORDER #{orders.orderId}</span>
                  </div>

                  <div className="custom-order-body">
                    <div className="meta-line">
                      <FiClock className="icon-purple" />
                      <p><b>Placed:</b> {getTimeAgo(orders?.createdAt)}</p>
                    </div>
                    <div className="meta-line mt-2">
                      <FiDollarSign className="icon-purple" />
                      <p><b>Amount:</b> <span className="dash-amount">₹{orders?.total}/-</span></p>
                    </div>
                  </div>

                  {/* Status Banner inside card */}
                  <div className={`custom-order-status status-${orders?.status?.toLowerCase() || 'pending'}`}>
                    STATUS: {orders?.status}
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-12">
                <Link to="/users/orders" className="custom-empty-card-funky">
                  <div className="empty-card-icon">
                    <FiShoppingBag size={24} />
                  </div>
                  <div className="empty-card-text">
                    <h5>No Recent Orders Found</h5>
                    <p>Click here to check your full order history or start shopping!</p>
                  </div>
                </Link>
              </div>
            )}
          </Row>
        </div>
      </div>
    </>
  );
}

export default Dashboard;